module.exports = __webpack_public_path__ + "img/sora-substrate.d6d99ee2.svg";